export const environment = {
    production: false,
    name: 'dev',
    END_POINT: '',
    configFile: 'assets/config/config.json',
};
